import { Chip, Purplex, White } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";

export const AiResponseFeedbackChip = styled(Chip)<{ selected: boolean }>(({ selected }) => ({
  ...(selected && {
    backgroundColor: Purplex[600],
    color: White.main,
    "&:hover": {
      backgroundColor: Purplex[700],
    },
  }),
}));
